import {
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
    outlinedInputClasses,
    Theme,
    OutlinedInputProps,
    inputBaseClasses,
} from '@mui/material';
import { StyleProps } from './utils/dynamicStyle';

function readOnlyRootStyle(props: StyleProps<OutlinedInputProps>) {
    return {
        [`&.${inputBaseClasses.readOnly}`]: {
            color: props.theme.palette.text.disabled,
            cursor: 'unset',
            [`&:hover`]: {
                [`& > .${outlinedInputClasses.notchedOutline}`]: {
                    borderColor: props.theme.palette.action.disabled,
                },
            },
            [`& .${outlinedInputClasses.notchedOutline}`]: {
                borderColor: props.theme.palette.action.disabled,
            },
        },
    };
}

export const MuiInputBase: {
    defaultProps?: ComponentsProps['MuiInputBase'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiInputBase'];
    variants?: ComponentsVariants['MuiInputBase'];
} = {
    defaultProps: {},
    styleOverrides: {
        root: {
            '& input[type="text"]': {
                // added to work around carrot-frontend global css
                boxSizing: 'content-box',
            },
        },
    },
};

export const MuiOutlinedInput: {
    defaultProps?: ComponentsProps['MuiOutlinedInput'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiOutlinedInput'];
    variants?: ComponentsVariants['MuiOutlinedInput'];
} = {
    defaultProps: {
        notched: false,
    },
    styleOverrides: {
        notchedOutline: (props) => ({
            borderWidth: props.theme.tokens.borderWidth.md,
        }),
        root: (props) => [
            {
                backgroundColor: props.theme.palette.background.paper,
                [`&:hover`]: {
                    [`& .${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: props.theme.palette.primary.main,
                    },
                    [`&.${inputBaseClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: props.theme.palette.action.disabled,
                    },
                },
                ...props.theme.typography.body1,
            },
            readOnlyRootStyle(props),
        ],
    },
    variants: [
        {
            props: { size: 'medium' },
            style: { minHeight: '3.625rem' },
        },
        {
            props: { size: 'small' },
            style: { minHeight: '2.75rem' },
        },
    ],
};
